import {
    Overlay,
    OverlayConfig,
    OverlayRef,
    ScrollStrategy,
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
    Component,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LynxModalService } from '../../../services/modal.service';

@Component({
    selector: 'lynx-loading-modal',
    templateUrl: './loading-modal.component.html',
    styleUrls: ['./loading-modal.component.scss'],
    standalone: false
})
export class LoadingModalComponent implements OnInit, OnDestroy {
  @ViewChild('modal', { static: true }) modal: TemplateRef<any>;
  private overlayRef: OverlayRef;
  private scrollStrategy: ScrollStrategy;
  private destroy$ = new Subject<boolean>();

  isSolidModalBg = false;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private modalService: LynxModalService
  ) {}

  ngOnInit() {
    this.initialize();

    this.modalService.isSolidModalBg$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isSolidModalBg: boolean) => {
        this.isSolidModalBg = isSolidModalBg;
      });

    this.modalService.isLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoading: boolean) => {
        if (isLoading && !this.overlayRef.hasAttached()) {
          this.overlayRef.attach(
            new TemplatePortal(this.modal, this.viewContainerRef)
          );
        } else {
          if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  private initialize(): void {
    const strategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    const config = new OverlayConfig({
      positionStrategy: strategy,
      scrollStrategy: this.scrollStrategy,
      width: `100%`,
      height: `100%`,
      panelClass: 'loading',
    });

    this.overlayRef = this.overlay.create(config);
  }
}
